import { Sparkles } from "lucide-react";
import { useLocation } from "react-router-dom";

// Routes where the public promo banner should NOT appear (admin/auth surfaces).
const HIDDEN_PREFIXES = ["/dashboard", "/auth"];

export default function AnnouncementBar() {
  const { pathname } = useLocation();
  if (HIDDEN_PREFIXES.some((p) => pathname === p || pathname.startsWith(`${p}/`))) {
    return null;
  }

  return (
    <div className="fixed safe-top-announcement left-0 right-0 z-[60] bg-secondary text-secondary-foreground">
      <div className="container flex items-center justify-center gap-2 py-1 text-center">
        <Sparkles className="w-3 h-3 shrink-0" aria-hidden />
        <p className="text-[11px] sm:text-xs font-black uppercase tracking-wider leading-tight">
          FREE Window Cleaning with Every Install
        </p>
        <Sparkles className="w-3 h-3 shrink-0 hidden sm:inline-block" aria-hidden />
      </div>
    </div>
  );
}
